import store from '@/store';

const defaultConfigs = {
    decimalCount: store.state.options.currency.decimals,
    decimal: store.state.options.currency.decimals_separator,
    thousands: store.state.options.currency.thousands_separator,
    sign: store.state.options.currency.symbol,
    signpos: store.state.options.currency.signpos,
};

function format(amount: any, configs?: any) {
    try {
        configs = configs || defaultConfigs;
        let decimalCount = Math.abs(configs.decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const decimal = configs.decimal;
        const thousands = configs.thousands;
        const negativeSign = amount < 0 ? '-' : '';

        const i: any = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString();
        const j = (i.length > 3) ? i.length % 3 : 0;

        const formattedValue = negativeSign + (j ? i.substr(0, j) + thousands : '')
            + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands)
            + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '');
        switch (configs.signpos) {
            case 'after':
                return formattedValue + '\u00A0' + configs.sign;
            case 'before':
                return configs.sign + '\u00A0' + formattedValue;
            default:
                throw Error('Sign position not supported');
        }
    } catch (e) {
        console.log(e);
    }
}

export default function(value: any, configs?: any) {
    return format(value, configs);
}
